var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileWithCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E1E7F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5013 16.3659C19.2144 16.3659 21.4323 14.148 21.4323 11.4349C21.4323 8.72176 19.2144 6.50391 16.5013 6.50391C13.7881 6.50391 11.5703 8.72176 11.5703 11.4349C11.5703 14.148 13.7882 16.3659 16.5013 16.3659Z",
    fill: "#7C8DB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9637 20.3065C24.8345 19.9835 24.6622 19.682 24.4684 19.4021C23.4779 17.9379 21.9491 16.9689 20.2265 16.732C20.0112 16.7105 19.7743 16.7536 19.6021 16.8828C18.6977 17.5503 17.6211 17.8948 16.5013 17.8948C15.3816 17.8948 14.305 17.5503 13.4006 16.8828C13.2283 16.7536 12.9915 16.689 12.7762 16.732C11.0535 16.9689 9.5032 17.9379 8.53424 19.4021C8.34045 19.682 8.16817 20.005 8.039 20.3065C7.97442 20.4357 7.99593 20.5864 8.06051 20.7156C8.23279 21.0171 8.4481 21.3186 8.64189 21.5769C8.94334 21.9861 9.26634 22.3521 9.63241 22.6966C9.93386 22.9981 10.2784 23.278 10.6229 23.5579C12.324 24.8284 14.3696 25.4959 16.4798 25.4959C18.59 25.4959 20.6356 24.8283 22.3367 23.5579C22.6812 23.2996 23.0257 22.9981 23.3272 22.6966C23.6717 22.3521 24.0163 21.986 24.3177 21.5769C24.5331 21.297 24.7269 21.0171 24.8991 20.7156C25.0067 20.5864 25.0282 20.4357 24.9637 20.3065Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWithCircle);
export default __webpack_public_path__ + "static/media/profile_with_circle.d80e965b0304547a031809239c968201.svg";
export { ForwardRef as ReactComponent };